var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 13,
    viewBox: "0 0 16 13",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.894 5.72979C14.1545 1.9182 11.525 0 8 0C4.47319 0 1.84551 1.9182 0.105961 5.7317C0.0361868 5.88538 0 6.05322 0 6.22318C0 6.39313 0.0361868 6.56098 0.105961 6.71466C1.84551 10.5262 4.47502 12.4444 8 12.4444C11.5268 12.4444 14.1545 10.5262 15.894 6.71275C16.0353 6.40354 16.0353 6.04472 15.894 5.72979V5.72979ZM8 11.0702C5.04019 11.0702 2.87309 9.50893 1.34456 6.22222C2.87309 2.93551 5.04019 1.37423 8 1.37423C10.9598 1.37423 13.1269 2.93551 14.6554 6.22222C13.1287 9.50893 10.9616 11.0702 8 11.0702ZM7.9266 2.86299C6.14301 2.86299 4.69705 4.36701 4.69705 6.22222C4.69705 8.07744 6.14301 9.58146 7.9266 9.58146C9.71019 9.58146 11.1561 8.07744 11.1561 6.22222C11.1561 4.36701 9.71019 2.86299 7.9266 2.86299ZM7.9266 8.35992C6.79075 8.35992 5.87143 7.40368 5.87143 6.22222C5.87143 5.04076 6.79075 4.08453 7.9266 4.08453C9.06244 4.08453 9.98176 5.04076 9.98176 6.22222C9.98176 7.40368 9.06244 8.35992 7.9266 8.35992Z",
    fill: "#7D828E",
    id: "Vector"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.ff433e8fb0fdd13cd9d6398074bc4d83.svg";
export { ForwardRef as ReactComponent };